
const doc = typeof document !== 'undefined' ? document : {};
const R_COOKIE_DELIM = /[\s]*;[\s]*/;
const EQUAL = '=';

const getKeyValueEntries = (cook = '') => {
    if (cook.includes(EQUAL)) {
        const [ key, value, ...rest ] = cook.split(EQUAL);
        return [ key, [value, ...rest].join(EQUAL)];
    }

    return [cook, cook];
};

const getCookies = (_cookies) => {
    // Say cookie one more time...
    const cookies = _cookies ?? doc.cookie ?? '';
    const cookieMap = new Map(cookies?.split(R_COOKIE_DELIM).map(getKeyValueEntries));

    return cookieMap;
}

export default getCookies;
